<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >
        <!-- TODO: <Search />-->        
        <div class="mb-3">
          <GeneratePDF
            :head="table.header"
            :itens="list"
            :title="'Pagamentos'"
            :items-per-page="8"
          />
          <GenerateExcel
            :head="table.header"
            :itens="list"
            :title="'Pagamentos'"
          />
        </div>

        <v-data-table
          v-if="table.content"
          class="elevation-0"
          :headers="table.header"
          :items="table.content"
          :item-key="'id'"
          :loading="table.isLoading"
          :items-per-page="table.paginate.inputPage.size"
          :options.sync="pagination"
          :server-items-length="table.total"
          :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50, 100],showFirstLastPage: true, showCurrentPage: true }"          
        >
          <template v-slot:item.value="{ item }">
            {{ item.value.formatted }}
          </template>

          <template v-slot:item.group="{ item }">
            {{ item.group ? item.group.label : '-' }}
          </template>

          <template v-slot:item.status="{ item }">            
            <v-chip
              class="ma-2"                
              :color="paymentStatusColor(item.status.raw)"
              text-color="white"                
            >
              {{ item.status.label }}
            </v-chip>            
          </template>

          <template v-slot:item.actions="{ item }">
            <router-link
              :to="{
                name: 'dashboard-pagamentos-detail',
                params: { id: item.id }
              }"
              title="Visualizar"
            >
              <v-icon>visibility</v-icon>
            </router-link>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import GenerateExcel from '@/components/GenerateExcel.vue';
  import GeneratePDF from '@/components/GeneratePDF.vue';
  import { paymentStatusColor } from '@/util/payment-status-color'; 

  export default {
    components: {      
      GenerateExcel,
      GeneratePDF,
    },

    data: () => ({
      pagination: null,
      list:null
    }),

    computed: {
      ...mapState('pagamento', ['table'])
    },

    watch: {
      pagination: {
        handler() {
          this.changePagination();
        },
        deep: true
      },

      'table.content': function () {
        this.paymentList()
      }
    },

    destroyed() {
      this.clear();
    },

    methods: {
      paymentStatusColor(status) {
        return paymentStatusColor(status);
      },

      changePagination() {
        const { page, itemsPerPage } = this.pagination;
        const paginate = {
          ...this.table.paginate,
          inputPage: {
            page: page,
            per_page: itemsPerPage,
            sort: 'id:desc'            
          }
        };
        this.changePage(paginate);
        this.search();        
      },

      goToForm({ id }) {
        this.$router.push({
          name: 'dashboard-pagamentos-detail',
          params: { id }
        });
      },

      paymentList() {
        const { content } = this.table;
        if(content.length===0) return;

        const formattedList = content.map(item => ({
          'Pagamento ID': item.id,
          'Grupo': item.group.label,
          'Número Pedido': item.solicitation_id,
          'Valor': item.value.formatted,
          'Empresa': item.company.name,
          'Data de Pagamento': item.paid_at.formatted,
          'Status': item.status.label,                
          'Data de Criação': item.created_at.formatted,
        }));

        this.list = formattedList;
      },

      ...mapActions('pagamento', { search: 'SEARCH' }),
      ...mapActions('pagamento', { clear: 'CLEAR' }),
      ...mapActions('pagamento', { changePage: 'CHANGE_PAGE' })
    },
  };
</script>
